module.exports = __webpack_public_path__ + "static/media/img7.5ca1d69d.png";